import { render, staticRenderFns } from "./company-profile.vue?vue&type=template&id=2c8317ea&scoped=true&"
import script from "./company-profile.vue?vue&type=script&lang=js&"
export * from "./company-profile.vue?vue&type=script&lang=js&"
import style0 from "./company-profile.vue?vue&type=style&index=0&id=2c8317ea&prod&scoped=true&lang=css&"
import style1 from "./company-profile.vue?vue&type=style&index=1&id=2c8317ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8317ea",
  null
  
)

export default component.exports